import { inject } from 'mobx-react';
import React from 'react';
import { Container } from 'reactstrap';

import { modelOf } from '../../../prop-types';
import UIStore from '../../../store/UIStore';
import SidebarLayout from '../../layout/SidebarLayout';
import PageSkeleton from '../PageSkeleton';
import SidebarSkeleton from '../SidebarSkeleton';

const InfoPageSkeleton = ({ uiStore }) => {
  return (
    <Container className="InfoPage__container">
      <SidebarLayout
        sidebarPlaceHolder={!uiStore.isMobile ? <SidebarSkeleton /> : null}
        content={<PageSkeleton />}
        contentPlaceHolder={<PageSkeleton />}
      />
    </Container>
  );
};

InfoPageSkeleton.propTypes = {
  uiStore: modelOf(UIStore).isRequired,
};

export default inject('uiStore')(InfoPageSkeleton);
